export default {
  LIST (state, value) {
    state.list = value && Array.isArray(value) ? value : []
  },
  FILTER (state, value) {
    state.filter = value || null
  }
}
